
export const Home = () => {
  return (
    <div className="home">
      HI, This App was created with some hooks - a custom hook known as
      useCounter coupled with useReducer. Navigate to the other pages to see the
      beauty I created.
    </div>
    
  );
};

export default Home;
